export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-v1-960-8f8785d4a7976b4eed3ef9e2afba6aac.webp";